import { styled } from '@mui/system'
import { Outlet, Route, Routes } from 'react-router-dom'
import Footer from '@/components/Footer'
import SectionErrorBoundary from '@/components/SectionErrorBoundary'
import { BlogPostCreate, BlogPostDetails, BlogPostList } from '@/routes'
import BlogNavbar from './BlogNavbar'

const BlogLayoutRoot = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    height: '100%',
    paddingTop: 64,
    // viewport-fit=cover: keep content out of the notch in landscape.
    paddingLeft: 'env(safe-area-inset-left, 0px)',
    paddingRight: 'env(safe-area-inset-right, 0px)'
}))

const BlogLayout = () => (
    <BlogLayoutRoot>
        <BlogNavbar />
        <SectionErrorBoundary label="blog-content">
            <Routes>
                <Route path="/" element={<BlogPostList />} />
                <Route path="new" element={<BlogPostCreate />} />
                <Route path=":postId" element={<BlogPostDetails />} />
            </Routes>
        </SectionErrorBoundary>
        <Footer />
    </BlogLayoutRoot>
)

export default BlogLayout
